import React, { Component } from 'react';
import '../App.css';
import { Panel }
  from 'react-bootstrap';

import SocialBox from '../Engines/SocialBox.js';

const engines = new Map();
var takenMedias;
var totalMedias;
//Description of this group.
//This is what user will see by pressing the info icon.
const description = (
  <div>
    These are the most important social media accounts matching your query:
  </div>
)

class SocialMedia extends Component {
  constructor () {
    super();
    engines.set("Twitter", {});
    engines.set("Facebook", {});
    // engines.set("Youtube", {});
    engines.set("Instagram", {});
    // engines.set("GooglePlus", {});
    this.state = {
      resultCount: 0,
      searchQuery: '',
      open: true,
      noSearches: true
    };
  }

  clear(){
    engines.set("Twitter", {});
    engines.set("Facebook", {});
    // engines.set("Youtube", {});
    engines.set("Instagram", {});
    // engines.set("GooglePlus", {});
    this.setState({
      resultCount: 0,
      query: '',
      open: true,
    });
  }

  addResult(source, content, query) {
    if (engines.has(source)) {
      engines.set(source, content)
      this.setState({
        resultCount: this.state.resultCount + 1,
        searchQuery: query,
        noSearches: false
      });
    }
  }

  setHeaderResults(){
    var taken = 0;
    var free = 0;
    var social1 = engines.get("Twitter");
    var social2 = engines.get("Facebook");
    var social3 = engines.get("Instagram");
    // var social4 = engines.get("Youtube");
    // var social5= engines.get("GooglePlus");
    // var list = [social1, social2, social3, social4, social5];
    var list = [social1, social2, social3];
    list.forEach((element) => {
      if(element[0] === 'TAKEN') {
        taken++;
      }
      else if(element[0] === 'AVAILABLE') {
        free++;
      }
    });
    takenMedias = taken;
    totalMedias = taken + free;
  }

  handleClick() {
    this.setState({open: !this.state.open});
  }

  header(){
    return(
      <div id="smpanel" className="resultBox__header" onClick={ ()=> this.setState({ open: !this.state.open })}>
        <div className="resultBox__title">
          Social Media
          <h2 className="resultBox__title results">{takenMedias}/{totalMedias} Are Taken</h2>
        </div>
      </div>
    );
  }

  render() {
    this.setHeaderResults()
      return (
        <Panel className="resultBox" collapsible expanded={this.state.open} header={this.header()}>
          <div className="resultBox__content clearfix">

            <div className="Description social">
                {description}
            </div>
            <div id="SocialMediaWell" className="SocialMediaWell">
              <SocialBox content={engines.get("Twitter")} searchQuery={this.state.searchQuery} source="Twitter" image={require('../../socialMediaLogos/twitter.png')} />
              <SocialBox content={engines.get("Facebook")} searchQuery={this.state.searchQuery} source="Facebook" image={require('../../socialMediaLogos/facebook.png')} />
              <SocialBox content={engines.get("Instagram")} searchQuery={this.state.searchQuery} source="Instagram" image={require('../../socialMediaLogos/instagram.png')} />
              {/* <SocialBox content={engines.get("Youtube")} searchQuery={this.state.searchQuery} source="Youtube" image={require('../../socialMediaLogos/youtube.png')} /> */}
              {/* <SocialBox content={engines.get("GooglePlus")} searchQuery={this.state.searchQuery} source="GooglePlus" image={require('../../socialMediaLogos/googleplus.png')} /> */}
            </div>

          </div>
          <div className="resultBox__footer">
          </div>
        </Panel>
      );
  }
}

export default SocialMedia;



// WEBPACK FOOTER //
// ./client/src/Groups/SocialMedia.js